(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    initAgeVerification();
  });

  // Also initialize when cart updates (for AJAX carts)
  document.addEventListener('cart:updated', function() {
    initAgeVerification();
  });

  function initAgeVerification() {
    const checkbox = document.getElementById('age-verification-checkbox');
    const checkoutButton = document.getElementById('checkout');
    const additionalCheckoutButtons = document.getElementById('additional-checkout-buttons-container');
    
    if (!checkbox || !checkoutButton) return;

    // Function to update button states
    function updateCheckoutButtons() {
      const isChecked = checkbox.checked;
      const isCartEmpty = checkoutButton.form && checkoutButton.form.elements.length === 0;
      
      // Enable/disable main checkout button
      if (isCartEmpty) {
        checkoutButton.disabled = true;
      } else {
        checkoutButton.disabled = !isChecked;
      }

      // Show/hide additional checkout buttons (Apple Pay, Google Pay, etc.)
      if (additionalCheckoutButtons) {
        additionalCheckoutButtons.style.display = isChecked ? 'block' : 'none';
      }
    }

    // Listen for checkbox changes
    checkbox.addEventListener('change', updateCheckoutButtons);

    // Initial state
    updateCheckoutButtons();

    // Prevent form submission if not checked
    const cartForm = document.getElementById('cart-form');
    if (cartForm) {
      cartForm.addEventListener('submit', function(e) {
        if (!checkbox.checked) {
          e.preventDefault();
          alert('Please confirm that you are 21+ and agree to the Terms & Conditions.');
          checkbox.focus();
        }
      });
    }
  }

  // For cart drawer - reinitialize when drawer opens
  if (customElements.get('cart-drawer-component')) {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open' && cartDrawer.hasAttribute('open')) {
            setTimeout(initAgeVerification, 100);
          }
        });
      });
      observer.observe(cartDrawer, { attributes: true });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    // Intersection Observer for scroll animations
  if (!window.scrollAnimationInitialized) {
    window.scrollAnimationInitialized = true;

    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -10% 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe elements on page load
    const animateElements = document.querySelectorAll('.scroll-animate');
    animateElements.forEach(el => observer.observe(el));

    // Re-observe when sections are loaded dynamically
    document.addEventListener('shopify:section:load', () => {
      const newElements = document.querySelectorAll('.scroll-animate:not(.animated)');
      newElements.forEach(el => observer.observe(el));
    });
  }
  } catch(e) { console.error(e); }
})();

})();
